
const dateFormat = require('bmh/date-format');
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const qs = require('qs');

function validateMapFormat() {
  return {
    weixin_nickname: {
      value: '',
      status: '',
      help: ''
    },
    weixin_number: {
      value: '',
      status: '',
      help: ''
    },
    mobile: {
      value: '',
      status: '',
      help: ''
    },
    charge: {
      value: '',
      status: '',
      help: ''
    },
    status: {
      value: 1,
      status: '',
      help: ''
    }
  };
}

enum enumMergeDialog {
  choose_company,
  confirm_data
}

const API = {
  get_follower_list: `${FCAPI}/boss/hundun/company/follower`,
  get_list: `${FCAPI}/boss/hundun/company/callback`,
  edit_follower: `${FCAPI}/boss/hundun/company/follower`,
  post_merge: `${FCAPI}/boss/hundun/company/merge`,
  post_status: `${FCAPI}/boss/hundun/company/status`,
  post_follower: `${FCAPI}/boss/hundun/company/followerrele`,
  delete_follower: `${FCAPI}/boss/hundun/company/followerrele/0`,
  post_contact: `${FCAPI}/boss/hundun/company/callback`,
  user_list: `${FCAPI}/boss/hundun/user`,
  add_log: `${FCAPI}/boss/hundun/company/log`
};

const employees_table: any = {
  '0': {
    employees_number_floor: 0,
    employees_number_ceil: 50
  },
  '1': {
    employees_number_floor: 51,
    employees_number_ceil: 100
  },
  '2': {
    employees_number_floor: 101,
    employees_number_ceil: 500
  },
  '3': {
    employees_number_floor: 501,
    employees_number_ceil: ''
  }
};

function initForm() {
  return {
    current: 1,
    limit: 20,
    // full_name: '',
    // part_name: '',
    full_or_part_name: '',
    callback_status: 0,
    callback_time: [] as any,
    cooperation_state: -2,
    present_follower_id: [],
    is_tube: undefined
  };
}

// function initMergeFrom() {
//   return {
//     full_name: '',
//     location: '',
//     industry: '',
//   }
// }

@Component
export default class TubiVisitList extends Vue {
  form_merge_company: any;
  more_change_form: any;
  form = initForm();
  merge_from = initForm();
  employees_id = '';
  is_loading = false;
  locale = zhCN;
  table_data: any = {};
  table_data_merge: any = {};
  select_row_key = [];
  select_row_data = []; //已选择的具体数据
  merge_select_row_data = []; //已选择的具体数据
  merge_select_row_key = [];
  more_change = [
    {
      id: 1,
      value: '跟进状态'
    },
    {
      id: 2,
      value: '目前跟进人'
    }
  ];
  show_add_tag = false; // 添加标签弹框
  more_id = -1; //批量修改类型选择www
  merge_dialog = false;
  enumMergeDialog = enumMergeDialog;
  merge_dialog_type = enumMergeDialog.choose_company;
  validate_map: any = validateMapFormat();
  follower_modal = false;
  contact_modal = false;
  is_edit = false;
  cooperation_type_map = [
    { name: '请选择', id: -2 },
    { name: '暂无明确需求，持续跟进', id: 1 },
    { name: '待匹配合作方案', id: 2 },
    { name: '已出合作方案待回复', id: 4 },
    { name: '待签约', id: 5 },
    { name: '已合作', id: 3 },
  ];
  follower_list: any = [];
  contact_post_id: any = [];
  select_students_name = '';
  user_table: any = {};
  choose_students_data: any = {};
  show_students_dialog = false;

  // 批量修改弹框
  moreEdit() {
    if (this.select_row_data.length === 0) {
      this.$message.error('请先勾选要批量修改的企业');
      return;
    }
    this.show_add_tag = true;
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }

  async search(page = 1) {
    // this.form_merge_company.resetFields(['full_name', 'standard']);
    this.init(page);
    console.log(this.form);
  }

  //翻页
  changePage(page: any) {
    this.init(page.current);
  }

  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }

  handleClear() {
    this.form = initForm();
    // this.init(1);
  }

  handleClearMerge() {
    this.merge_from = initForm();
    // this.initMerge(1);
  }

  changeMoretype(id: number) {
    this.form_merge_company.resetFields(['full_name', 'standard']);
    this.more_id = id;
  }

  async init(page = 1) {
    // const url = getUrl(API.get_list, { ...this.form, current: page, present_follower_id: this.form.present_follower_id.toString() });
    // const res: any = await this.$axios.get(
    //   `${API.get_list}?${qs.stringify({
    //     ...this.form,
    //     current: page,
    //     present_follower_id: this.form.present_follower_id.toString()
    //   })}`
    // );
    let callback_start_time = this.form.callback_time[0] ? Math.floor((this.form.callback_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let callback_end_time = this.form.callback_time[1] ? Math.floor((this.form.callback_time[1] as any).hours(0).minutes(0).seconds(0) / 1000) + 86400 : '';
    const send_data = {
      // full_name: this.form.full_or_part_name ? this.form.full_or_part_name : '',
      // part_name: this.form.full_or_part_name ? this.form.full_or_part_name : '',
      full_or_part_name: this.form.full_or_part_name ? this.form.full_or_part_name : '',
      callback_status: this.form.callback_status ? this.form.callback_status : '',
      callback_start_time: callback_start_time,
      callback_end_time: callback_end_time,
      cooperation_state: isNaN(this.form.cooperation_state) ? undefined : this.form.cooperation_state,
      present_follower_id: this.form.present_follower_id.toString(),
      is_tob: this.form.is_tube,
      current: page,
      limit: 20
    };
    // const url = getUrl(API.get_list, send_data);
    // const res: any = await this.$axios.get(url);
    const res: any = await this.$axios.get(API.get_list, { params: send_data });
    // const res: any = await this.$axios.get(
    //   `${API.get_list}?${qs.stringify({
    //     ...this.form,
    //     current: page,
    //     present_follower_id: this.form.present_follower_id.toString()
    //   })}`
    // );
    if (res.data.data) {
      res.data.data.detail.forEach((element: any) => {
        element.follower_separate = element.follower_separate.map((item: any) => item.follower_id);
      });
    }
    this.table_data = res.data.data ? res.data.data : [];
    this.select_row_key = [];
  }

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  submit() {
    this.contact_post_id = this.select_row_key;
    this.contact_modal = true;
    console.log(2);
  }

  beforeCreate() {
    this.form_merge_company = this.$form.createForm(this);
    this.more_change_form = this.$form.createForm(this);
  }

  handleView(record: any) {
    console.log(record);
    this.$router.push({
      path: '/hundun/company-detail',
      query: { id: record.id, name: record.full_name }
    });
  }

  async confirmEdit() {
    let is_valid = true;
    if (!this.validate_map.weixin_nickname.value) {
      this.validate_map.weixin_nickname.status = 'error';
      this.validate_map.weixin_nickname.help = '请输入微信昵称';
      is_valid = false;
    }
    if (!this.validate_map.weixin_number.value) {
      this.validate_map.weixin_number.status = 'error';
      this.validate_map.weixin_number.help = '请输入微信号';
      is_valid = false;
    }
    if (!this.validate_map.charge.value) {
      this.validate_map.charge.status = 'error';
      this.validate_map.charge.help = '请输入负责人';
      is_valid = false;
    }
    if (!is_valid) {
      return;
    }
    const send_data = {
      weixin_nickname: this.validate_map.weixin_nickname.value,
      weixin_number: this.validate_map.weixin_number.value,
      mobile: this.validate_map.mobile.value,
      charge: this.validate_map.charge.value,
      status: this.validate_map.status.value
    };
    const res: any = this.is_edit ? await this.$axios.put(API.post_merge, send_data) : await this.$axios.post(API.edit_follower, send_data);
    if (res.data.status === 200) {
      this.$message.success(this.is_edit ? '编辑成功' : '新增成功');
    }
    this.follower_modal = false;
  }

  async addLog(log: any, item: any) {
    if (!log) {
      this.$message.error('请输入备注');
      return;
    }
    const send_data = {
      company_id: item.id,
      content: `备注  “${log}”`
    };
    const res: any = await this.$axios.post(API.add_log, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      item.explain = '';
    }
  }

  async initFollower() {
    const send_data = {
      current: 1,
      limit: 999999,
      weixin_nickname: '',
      mobile: '',
      charge: '',
      status: 0
    };
    const url = getUrl(API.get_follower_list, send_data);
    const res: any = await this.$axios.get(url);
    this.follower_list = res.data.data
      ? [
        {
          id: 0,
          weixin_nickname: '无'
        },
        ...res.data.data.detail
      ]
      : [
        {
          id: 0,
          weixin_nickname: '无'
        }
      ];
  }

  async axiosCooperation(list: any, id: number) {
    const res: any = await this.$axios.post(API.post_status, {
      id_list: list,
      cooperation_state: id
    });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
    }
  }

  async handleEditCooperation(record: any) {
    console.log(record);
    await this.axiosCooperation([record.id], record.cooperation_state);
  }
  async handleEditFollower(value: any, record: any, is_delete: any = false) {
    const follower_name: any = this.follower_list.filter((item: any) => {
      return item.id === value;
    })[0];
    console.log(follower_name.weixin_nickname);
    const res: any = is_delete
      ? await this.$axios.delete(`${API.delete_follower}?company_id=${record.id}&follower_id=${value}`)
      : await this.$axios.post(API.post_follower, {
        company_id: record.id,
        follower_id: value,
        follower_name: follower_name.weixin_nickname
      });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
    }
  }

  handleContact(item: any) {
    console.log(item);
    this.contact_post_id = item;
    this.contact_modal = true;
  }

  async confirmContact() {
    const res: any = await this.$axios.post(API.post_contact, {
      id_list: this.contact_post_id
    });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
      this.select_row_key = [];
      this.select_row_data = [];
      this.contact_modal = false;
      this.show_add_tag = false;
      this.init();
    } else if (res.data.status === 503) {
      this.$message.error('没有权限操作');
      this.select_row_key = [];
      this.select_row_data = [];
      this.contact_modal = false;
      this.show_add_tag = false;
      this.init();
    }
  }

  onSelectChange(select_row_key: any, value: any) {
    this.select_row_data = value;
    this.select_row_key = select_row_key;
  }

  typeFormat(item: any) {
    console.log(item.full_name);
    console.log(item.last_order_end_time - Number(new Date()) / 1000);
    let str = '';

    if (item.last_order_end_time) {
      if (30 * 86400 >= item.last_order_end_time - Number(new Date()) / 1000) {
        str = '紧急过期提醒';
      }
      if (30 * 86400 < item.last_order_end_time - Number(new Date()) / 1000 && item.last_order_end_time - Number(new Date()) / 1000 <= 90 * 86400) {
        str = '过期提醒';
      }
    }
    if (item.callback_time) {
      if (item.callback_time <= Number(new Date()) / 1000) {
        str = str ? str + ';回访' : '回访';
      }
    }
    return str ? str : '-';
  }

  async initUser(page = 1) {
    const send_data = {
      current: page,
      limit: 10,
      corp_name: this.choose_students_data.full_name,
      sort: 'keyman'
    };
    const url = getUrl(API.user_list, send_data);
    const res: any = await this.$axios.get(url);
    this.user_table = res.data.data ? res.data.data : [];
  }

  handleShowStudents(item: any) {
    this.select_students_name = `${item.full_name}/`;
    console.log(item);
    this.user_table = {};
    this.choose_students_data = item;
    this.show_students_dialog = true;
    this.initUser(1);
  }

  //翻页
  changeUserPage(page: any) {
    this.initUser(page.current);
  }
  async created() {
    await this.initFollower();
    if (this.$route.query?.time) {
      this.form.callback_time = [moment(1451577600000), moment(Number(this.$route.query?.time) * 1000)];
      this.form.present_follower_id = this.follower_list.filter((item: any) => this.$route.query?.name == item.charge).map((item: any) => item.id) || [];
    }

    this.init();
  }
}
